export default __webpack_public_path__ + "static/media/calendar.12ba4060.svg";